var map = {
	"./argonomic.svg": 98283,
	"./bin_management.svg": 74395,
	"./full_portfolio.svg": 74610,
	"./grower_crm.svg": 29805,
	"./live_market.png": 89773,
	"./logistics.svg": 81025,
	"./messages.png": 92850,
	"./news_alerts.svg": 92389,
	"./private.svg": 77121,
	"./selling.png": 13240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21640;